import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Dashboard = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({
    totalTasks: 0,
    completedTasks: 0,
    totalVendors: 0,
    totalGuests: 0,
    acceptedGuests: 0,
    budgetTotal: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const card_id = localStorage.getItem('id');
  const budgetCurrencyCode = localStorage.getItem('budgetCurrency') || 'USD';
  const currencySymbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
  };
  const budgetCurrency = currencySymbols[budgetCurrencyCode] || '$';

  useEffect(() => {
    if (!card_id) {
      setError('No card ID found in local storage.');
      setLoading(false);
      return;
    }

    const fetchDashboardData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/planner/dashboard?card_id=${card_id}`);
        setStats(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return <div className="text-center py-10">{t('common.loading')}</div>;
  }

  if (error) {
    return <div className="text-center py-10 text-red-500">{t('common.error')}: {error}</div>;
  }

  return (
    <div className="max-w-4xl mx-auto py-10 px-2">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-3xl font-bold text-primary">{t('welcome')}</h1>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="bg-white rounded shadow p-6 flex flex-col gap-2">
          <span className="text-foreground/70">{t('navigation.planning')}</span>
          <span className="text-2xl font-bold text-primary">{stats.completedTasks} / {stats.totalTasks}</span>
          <Link to="/planning" className="text-info hover:underline">{t('navigation.checklist')}</Link>
        </div>
        <div className="bg-white rounded shadow p-6 flex flex-col gap-2">
          <span className="text-foreground/70">{t('navigation.vendors')}</span>
          <span className="text-2xl font-bold text-primary">{stats.totalVendors}</span>
          <Link to="/vendors" className="text-info hover:underline">{t('navigation.vendors')}</Link>
        </div>
        <div className="bg-white rounded shadow p-6 flex flex-col gap-2">
          <span className="text-foreground/70">{t('common.guests')} (Accepted)</span>
          <span className="text-2xl font-bold text-primary">{stats.acceptedGuests} / {stats.totalGuests}</span>
          <a href={`${process.env.REACT_APP_RSVP_BASE_URL}/${card_id}`} target="_blank" rel="noopener noreferrer" className="text-info hover:underline">{t('common.manageGuests')}</a>
        </div>
        <div className="bg-white rounded shadow p-6 flex flex-col gap-2">
          <span className="text-foreground/70">{t('navigation.budget')}</span>
          <span className="text-2xl font-bold text-primary">{budgetCurrency}{(parseFloat(stats.budgetTotal) || 0).toFixed(2)}</span>
          <Link to="/budget" className="text-info hover:underline">{t('navigation.budget')}</Link>
        </div>
      </div>
      <div className="bg-accent/20 rounded p-6 text-center">
        <span className="text-lg font-medium text-accent">{t('dashboard.welcomeMessage')}</span>
      </div>
    </div>
  );
};

export default Dashboard;
